import { restClient } from '@/Core'

import type { IUploadedPhoto } from '../Contracts/IProfile'

/**
 * Перший крок заміни фото: `POST /services/user/photo_files`, `multipart`.
 *
 * Файл іде як є. Легасі й PD перепаковували його в `image/jpeg` через base64 —
 * PNG з прозорістю чи WEBP отримували чужий тип (D-29). Стискає фото бек
 * (ADR 032). Прикріплює його до людини другий крок — `PATCH {photo}`; до того
 * файл — сирота, і підписане посилання на нього не відкривається.
 */
export const UploadUserPhotoTask = async (file: File): Promise<IUploadedPhoto> => {
    const body = new FormData()

    body.append('file', file, file.name)

    const response = await restClient.post('/services/user/photo_files', { body }, { isNotHeaderAddContentType: true })

    return (response ?? {}) as unknown as IUploadedPhoto
}
